import { render, staticRenderFns } from "./LeftTabAction.vue?vue&type=template&id=23b4b45d&scoped=true&"
import script from "./LeftTabAction.vue?vue&type=script&lang=js&"
export * from "./LeftTabAction.vue?vue&type=script&lang=js&"
import style0 from "./LeftTabAction.vue?vue&type=style&index=0&id=23b4b45d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b4b45d",
  null
  
)

export default component.exports